import { useQuery } from '@tanstack/react-query';
import { companyRelationshipApi } from 'shared/services/companyRelationshipApi';
import { queryKeys } from '../queryConfig';

/**
 * Whether the CURRENT session's active company should be locked to the
 * exclusive submit/review screen instead of the normal app — the case of a
 * provider's own company_admin, lent externally to a client whose
 * relationship has blockUnverifiedAccess on and isn't yet compliant. Login
 * and switch-company deliberately let this specific caller through instead
 * of rejecting them (see getBlockedExternalCompanyIds), and Layout.tsx
 * checks this on every mount to decide whether to render the restricted
 * screen instead of the sidebar + normal routes.
 *
 * Purely a UX gate — the submit/review endpoints have their own
 * authorization independent of this.
 */
export function useRestrictedProviderAccess() {
  const query = useQuery({
    queryKey: queryKeys.relationshipVerifications.myRestrictedAccess(),
    queryFn: () => companyRelationshipApi.getMyRestrictedAccess(),
    staleTime: 30 * 1000,
  });

  return {
    restricted: query.data?.restricted === true,
    relationshipId: query.data?.relationshipId,
    providerCompanyId: query.data?.providerCompanyId,
    // Treat the unresolved state as "not yet known" rather than restricted
    // — Layout.tsx should keep the normal shell (or a brief loader) up
    // rather than flash the restricted screen before the check resolves.
    loading: query.isLoading,
  };
}
